class SwatchCarousel extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('.swatches');
    this.prev_btn = this.querySelector('.nav.prev');
    this.next_btn = this.querySelector('.nav.next');
    this.wrapper = this.querySelector('.swatch-wrapper');
    this.swatches = this.querySelectorAll('.swatch');

    if (!this.container || !this.prev_btn || !this.next_btn || this.swatches.length === 0 || !this.wrapper) return;

    this.prev_btn.addEventListener('click', () => {
      const scrollAmount = this.wrapper.offsetWidth;
      this.container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    this.next_btn.addEventListener('click', () => {
      const scrollAmount = this.wrapper.offsetWidth;
      this.container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    this.container.addEventListener('scroll', () => this.updateArrowStates());
    this.updateArrowStates();
  }

  updateArrowStates() {
    const scrollLeft = this.container.scrollLeft;
    const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

    this.prev_btn.style.display = scrollLeft <= 0 ? 'none' : 'flex';
    this.next_btn.style.display = scrollLeft >= maxScrollLeft - 5 ? 'none' : 'flex';
  }
}

customElements.define('swatch-carousel', SwatchCarousel);
